<template>
  <div>
    <template v-if="projectEvidenceDate === null">
      <vs-button color="success" @click="projectEvidenceAcceptHandler()">
        Aceptar evidencias del proyecto
      </vs-button>
    </template>

    <template v-else>
      <vs-button color="danger" @click="projectEvidenceRejectHandler()">
        Rechazar evidencias del proyecto
      </vs-button>
    </template>
  </div>
</template>

<script>
export default {
  name: "ProjectEvidenceDateButton",
  props: {
    projectEvidenceDate: {
      type: String,
      required: true
    },
    projectId: {
      type: Number,
      required: true
    }
  },
  methods: {
    async projectEvidenceAcceptHandler() {
      if (confirm("¿Esta seguro de aceptar las evidencias del proyecto?")) {
        this.$vs.loading();
        try {
          const {data} = await axios.put(`/api/v1/project/${this.projectId}/evidence/accept`)
          this.projectEvidenceDate = data.complete_evidence_date;
        } finally {
          this.$vs.loading.close();
        }
      }
    },
    async projectEvidenceRejectHandler() {
      this.$vs.loading();
      try {
        const {data} = await axios.put(`/api/v1/project/${this.projectId}/evidence/reject`)
        this.projectEvidenceDate = data.complete_evidence_date;
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>

<style scoped>

</style>
